/* eslint-disable import/prefer-default-export */
export function normifyRole(roleToNormify) {
  let normifiedRole = roleToNormify;
  normifiedRole = normifiedRole[0].toUpperCase() + normifiedRole.slice(1);
  return normifiedRole;
}
